import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-5 mb-xl-10" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-header border-0 cursor-pointer bg-success",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#register_trainee",
    "aria-expanded": "true",
    "aria-controls": "form"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Certificate Template List")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    id: "register_trainee",
    class: "collapse show"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "collapse show" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body border-top p-9" }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "current",
          "data-kt-stepper-element": "content"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
            /*#__PURE__*/_createElementVNode("div", {
              style: {"margin-top":"2rem !important","float":"right"},
              class: "col-md-2 mt-14"
            }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "${this.VUE_APP_TMS}/certificate/training-certificate-configuration",
                type: "button",
                class: "btn btn-success p-3",
                style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
              }, " Add Template")
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "card mb-5 mb-xl-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#description",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Certificate Preview")
  ])
], -1)
const _hoisted_5 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-6" }
const _hoisted_8 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_9 = { class: "card mb-5 mb-xl-10" }
const _hoisted_10 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_11 = { class: "collapse show" }
const _hoisted_12 = { class: "card-body border-top" }
const _hoisted_13 = { class: "logo" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  style: {"float":"left","margin-left":"87px","margin-top":"69px","height":"62px","width":"133px"},
  src: "https://seeklogo.com/images/S/seip-skills-for-employment-investment-program-logo-57AF59698D-seeklogo.com.png",
  alt: "Logo 1"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"21%","margin-top":"69px","height":"58px","width":"120px","float":"left"},
  src: "https://cdn.worldvectorlogo.com/logos/bangladesh-govt-logo-vector.svg",
  alt: "Logo 1"
}, null, -1)
const _hoisted_16 = { style: {"float":"left","margin-left":"-479px","margin-top":"156px"} }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "certificate-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "center",
      style: {"font-famly":"Olde-English"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "h3 negrito-2 serif text-uppercase" }, "Certificate in "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "serif h3" }, " -------------------------------------------------------------------- "),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("p", {
        class: "esquerda",
        style: {"text-align":"center"}
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "h3 negrito-2 serif text-uppercase" }, "is awarded to"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("span", { class: "serif h3" }, " -------------------------------------------------------------------- ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      style: {"text-align":"justify"},
      class: "serif pt-3"
    }, [
      /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify"} }, [
        /*#__PURE__*/_createTextVNode(" Son/Daughter of "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "--------------------------------"),
        /*#__PURE__*/_createTextVNode(" and "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "-------------------------------- "),
        /*#__PURE__*/_createTextVNode(" for having achieved the units of competency through training program "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " ------------------ "),
        /*#__PURE__*/_createTextVNode(" hours held from "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "-------------------- "),
        /*#__PURE__*/_createTextVNode(" to "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " ----------------------- "),
        /*#__PURE__*/_createTextVNode(" at "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " -------------------------------------------------------------------- "),
        /*#__PURE__*/_createTextVNode(" supported by the Skills for Employment Investment Program (SEIP), Finance Division, Ministry Of Finance, Government of Bangladesh. ")
      ])
    ])
  ])
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20%"} }, null, -1)
const _hoisted_20 = {
  class: "d-flex justify-content-between",
  style: {"width":"90%","margin":"0 auto"}
}
const _hoisted_21 = {
  key: 0,
  style: {"width":"17%"}
}
const _hoisted_22 = ["src"]
const _hoisted_23 = { style: {"width":"80px","height":"80px"} }
const _hoisted_24 = {
  key: 1,
  style: {"width":"17%"}
}
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 auto"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "Issued On 20 June 2023")
], -1)
const _hoisted_27 = {
  key: 0,
  class: "card"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center bg-success border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-light h3" }, "Template List")
  ])
], -1)
const _hoisted_29 = { class: "card-body pt-4" }
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-eye" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_CertificateEditModal = _resolveComponent("CertificateEditModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_Form, {
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_ctx.showDataTable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", {
                                  style: _normalizeStyle({ 'background-image': 'url(' + this.VUE_APP_API_URL + '/storage/images/CertificateBackground/ttt.gif' + ')', 'background-repeat': 'no-repeat' }),
                                  class: "certificate"
                                }, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _hoisted_14,
                                    _hoisted_15,
                                    _createElementVNode("h3", _hoisted_16, " Registration No : " + _toDisplayString(_ctx.registration_number), 1),
                                    (_ctx.entityInfos[0].file_path)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          style: {"float":"right","margin-right":"85px","margin-top":"70px","height":"81px","width":"137px"},
                                          src: `${this.VUE_APP_API_URL}${_ctx.entityInfos[0]?.file_path}`,
                                          alt: "Logo 2"
                                        }, null, 8, _hoisted_17))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _hoisted_18,
                                  _hoisted_19,
                                  _createElementVNode("div", _hoisted_20, [
                                    (_ctx.BackgroundInfos.left)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                          _createElementVNode("p", null, [
                                            (_ctx.BackgroundInfos.left?.[0]?.left_signature)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  style: {"height":"50px","width":"100px"},
                                                  src: `${this.VUE_APP_API_URL}${_ctx.BackgroundInfos.left?.[0]?.left_signature}`,
                                                  alt: "Logo 2"
                                                }, null, 8, _hoisted_22))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("p", null, _toDisplayString(_ctx.BackgroundInfos.left?.[0]?.left_signatory), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(_component_qrcode_vue, { value: _ctx.qrData }, null, 8, ["value"])
                                    ]),
                                    (_ctx.BackgroundInfos.right)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                          _createElementVNode("p", null, [
                                            (_ctx.BackgroundInfos.right?.[0]?.right_signature)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  style: {"height":"50px","width":"100px"},
                                                  src: `${this.VUE_APP_API_URL}${_ctx.BackgroundInfos.right?.[0]?.right_signature}`,
                                                  alt: "Logo 2"
                                                }, null, 8, _hoisted_25))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("p", null, _toDisplayString(_ctx.BackgroundInfos.right?.[0]?.right_signatory), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 4),
                                _hoisted_26
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["validation-schema"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.showTable)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(), _createBlock(_component_Datatable, {
              "table-data": _ctx.Infos,
              "table-header": _ctx.tableHeader,
              key: _ctx.componentKey
            }, {
              "cell-entity": _withCtx(({ row: Infos }) => [
                _createTextVNode(_toDisplayString(Infos?.entityinfo?.entity_short_name), 1)
              ]),
              "cell-photo": _withCtx(({ row: Infos }) => [
                (Infos?.left_signature)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      style: {"width":"50px","height":"50px"},
                      src: `${this.VUE_APP_API_URL}${Infos?.left_signature}`,
                      alt: ""
                    }, null, 8, _hoisted_30))
                  : _createCommentVNode("", true)
              ]),
              "cell-photonext": _withCtx(({ row: Infos }) => [
                (Infos?.right_signature)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      style: {"width":"50px","height":"50px"},
                      src: `${this.VUE_APP_API_URL}${Infos?.right_signature}`,
                      alt: ""
                    }, null, 8, _hoisted_31))
                  : _createCommentVNode("", true)
              ]),
              "cell-left": _withCtx(({ row: Infos }) => [
                _createTextVNode(_toDisplayString(Infos?.left_signatory), 1)
              ]),
              "cell-right": _withCtx(({ row: Infos }) => [
                _createTextVNode(_toDisplayString(Infos?.right_signatory), 1)
              ]),
              "cell-actions": _withCtx(({ row: Infos }) => [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.Delete(Infos.id)),
                  title: "Delete",
                  class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm me-1"
                }, _hoisted_34, 8, _hoisted_32),
                ((Infos?.id !== null))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      "data-kt-drawer-toggle": "true",
                      "data-kt-drawer-target": "#kt_drawer_certificate_update",
                      onClick: ($event: any) => (_ctx.edit(Infos)),
                      id: "kt_drawer_certificate_update_button",
                      title: "Edit",
                      class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                    }, _hoisted_37, 8, _hoisted_35))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.view(Infos.id)),
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#industry_details",
                  class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                }, _hoisted_40, 8, _hoisted_38)
              ]),
              _: 1
            }, 8, ["table-data", "table-header"]))
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_CertificateEditModal)
  ], 64))
}